<mat-form-field class="w-full flex flex-row">
  <mat-label>{{ label() }}</mat-label>

  <input
    matInput
    [disabledInteractive]="false"
    [type]="showPassword() ? 'text' : 'password'"
    [formControl]="control()"
    [placeholder]="placeholder()"
  />

  <mat-icon
    matSuffix
    (click)="toggleVisibility()"
  >
    {{ showPassword() ? 'visibility_off' : 'visibility' }}
  </mat-icon>

  @if (control().invalid) {
    <mat-error>{{ errorMsg() }}</mat-error>
  }
</mat-form-field>
